import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f7192df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guide-container" }
const _hoisted_2 = { class: "guide-body" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "유의사항",
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }),
    _createVNode($setup["SegmentedControl"], {
      ref: "segmentedControl",
      segments: $setup.guideTitles,
      initialIndex: $setup.currentSegmentIndex,
      onOnChangedSegmentIndex: $setup.onChangedSegmentIndex
    }, null, 8 /* PROPS */, ["segments", "initialIndex"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        innerHTML: 
          $setup.DOMPurify.sanitize($setup.operationInfos[$setup.currentSegmentIndex]?.content)
        
      }, null, 8 /* PROPS */, _hoisted_3)
    ])
  ]))
}